import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Input, Form, FormFeedback, CardTitle, InputGroup, CardFooter, Button, Spinner } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import ModalContext from "../../contexts/ModalContext";
import { GetTagSetting, UpdateTagSettings } from "services/api/module/TagSettings";
import Spinners from "components/Common/Spinner";
import Error401 from "components/Error401";
import { checkScope } from "helpers/utility_helper";

const TagSettings = ({
    pageView = "update"
}) => {
    const _routeLink = `tag-settings`;
    const _routePermission = `tag-settings`
    // POPUP
    const { mAlert } = useContext(ModalContext);

    const qParams = useParams()
    const navigate = useNavigate();

    const [ waitSendData, setWaitSendData ] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)

    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        gtm_id: Yup.string(),
        ga_id: Yup.string(),
        fb_pixel_id: Yup.string(),
        cookie_script: Yup.string(),
        // noticeId: Yup.string(),
        // callbackUrl: Yup.string(),
        // privacyNoticeUrl: Yup.string(),
    })

    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            gtm_id: "",
            ga_id: "",
            fb_pixel_id: "",
            cookie_script: "",
            // noticeId: "",
            // callbackUrl: "",
            // privacyNoticeUrl: "",
            update_date: "",
        },
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log("🚀 ~ TagSettingsUpdate ~ values:", values)
            const payload = {
                gtm_id: values.gtm_id,
                ga_id: values.ga_id,
                fb_pixel_id: values.fb_pixel_id,
                cookie_script: values.cookie_script,
                // noticeId: values.noticeId,
                // callbackUrl: values.callbackUrl,
                // privacyNoticeUrl: values.privacyNoticeUrl,
            };
            console.log("🚀 ~ onSave ~ payload:", payload);

            setWaitSendData(true)
            API.fetchUpdateTagSettings(payload)
        },
    })

    const preFilInput = (resData = {}) => {
        // console.log("🚀 ~ preFilInput ~ resData:", resData)
        validation.setFieldValue("gtm_id", resData.gtmId)
        validation.setFieldValue("ga_id", resData.gaId)
        validation.setFieldValue("fb_pixel_id", resData.fbPixelId)
        validation.setFieldValue("cookie_script", resData.cookieScript)
        // validation.setFieldValue("noticeId", resData.noticeId)
        // validation.setFieldValue("callbackUrl", resData.callbackUrl)
        // validation.setFieldValue("privacyNoticeUrl", resData.privacyNoticeUrl)
        // validation.setFieldValue("update_date", resData.updateDate)
    }

    const API = {
        fetchGetTagSettings: async () => {
            try {
                const response = await GetTagSetting()
                const resData = response.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Cannot get Tag Settings",
                    content: "",
                    onClose: () => {
                    //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },
        fetchUpdateTagSettings: async (payload) => {
            try {
                const response = await UpdateTagSettings({ data: payload})
                const resData = response.data
                if (resData.status === 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Tag Settings Success",
                        content: "",
                        onClose: () => {
                          window.location.reload()
                        },
                    })
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Cannot update Tag Settings",
                    content: "",
                    onClose: () => {
                    //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
          }
    }

    // กรณี Edit
    useEffect(() => {
        setContentLoading(true)
        API.fetchGetTagSettings()
    }, [])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `Tag Settings | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE
    
    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }

    return (
      <>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
                title={`Update Tag Settings`}
                breadcrumbItem={`Update Tag Settings`}
            />

            {
                contentLoading
                ? <Spinners setLoading={setContentLoading} />
                :
                <Row>
                    <Form
                        className="form-horizontal"
                        onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                            return false
                        }}
                    >
                        <Col md={12}>
                            <Row>
                                <Col md={8}>
                                    <Card>
                                        <CardBody>
                                            <CardTitle className="h4">Tag Settings</CardTitle>
                                            <Row className="mb-3">
                                                <Col className="col-12">
                                                    <label
                                                        htmlFor="gtm_id"
                                                        className="col-md-12 col-form-label"
                                                    >
                                                        Google Tag Manager ID
                                                        {/* <span className="t-require">*</span> */}
                                                    </label>
                                                    <div className="col-md-12">
                                                        <Input
                                                            id="gtm_id"
                                                            className="form-control"
                                                            type="text"
                                                            placeholder=""
                                                            name="gtm_id"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.gtm_id}
                                                            invalid={validation.touched.gtm_id && validation.errors.gtm_id ? true : false}
                                                            disabled={pageView === "view"}
                                                        />
                                                        { 
                                                            validation.touched.gtm_id && validation.errors.gtm_id && (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.gtm_id}
                                                            </FormFeedback>
                                                            )
                                                        }
                                                    </div>
                                                </Col>
                                                <Col className="col-12">
                                                    <label
                                                        htmlFor="ga_id"
                                                        className="col-md-12 col-form-label"
                                                    >
                                                        Google Analytics ID
                                                    </label>
                                                    <div className="col-md-12">
                                                        <Input
                                                            id="ga_id"
                                                            className="form-control"
                                                            type="text"
                                                            placeholder=""
                                                            name="ga_id"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.ga_id}
                                                            invalid={validation.touched.ga_id && validation.errors.ga_id ? true : false}
                                                            disabled={pageView === "view"}
                                                        />
                                                        { 
                                                            validation.touched.ga_id && validation.errors.ga_id && (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.ga_id}
                                                            </FormFeedback>
                                                            )
                                                        }
                                                    </div>
                                                </Col>
                                                <Col className="col-12">
                                                    <label
                                                        htmlFor="fb_pixel_id"
                                                        className="col-md-12 col-form-label"
                                                    >
                                                        Facebook Pixel ID
                                                    </label>
                                                    <div className="col-md-12">
                                                        <Input
                                                            id="fb_pixel_id"
                                                            className="form-control"
                                                            type="text"
                                                            placeholder=""
                                                            name="fb_pixel_id"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.fb_pixel_id}
                                                            invalid={validation.touched.fb_pixel_id && validation.errors.fb_pixel_id ? true : false}
                                                            disabled={pageView === "view"}
                                                        />
                                                        { 
                                                            validation.touched.fb_pixel_id && validation.errors.fb_pixel_id && (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.fb_pixel_id}
                                                            </FormFeedback>
                                                            )
                                                        }
                                                    </div>
                                                </Col>
                                                <Col className="col-12">
                                                    <label
                                                        htmlFor="cookie_script"
                                                        className="col-md-12 col-form-label"
                                                    >
                                                        OneTrust Cookies Settings button
                                                    </label>
                                                    <div className="col-md-12">
                                                        <Input
                                                            id="cookie_script"
                                                            className="form-control"
                                                            type="textarea"
                                                            rows="10"
                                                            placeholder=""
                                                            name="cookie_script"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.cookie_script}
                                                            invalid={validation.touched.cookie_script && validation.errors.cookie_script ? true : false}
                                                            disabled={pageView === "view"}
                                                        />
                                                        { 
                                                            validation.touched.cookie_script && validation.errors.cookie_script && (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.cookie_script}
                                                            </FormFeedback>
                                                            )
                                                        }
                                                    </div>
                                                </Col>
                                                {/* <Col className="col-12">
                                                    <label
                                                        htmlFor=""
                                                        className="col-md-12 col-form-label"
                                                    >
                                                        One Trust Privacy Notice
                                                    </label>
                                                    <label
                                                        htmlFor="noticeId"
                                                        className="col-md-12 col-form-label"
                                                    >
                                                        Notice ID
                                                    </label>
                                                    <div className="col-md-12">
                                                        <Input
                                                            id="noticeId"
                                                            className="form-control"
                                                            type="text"
                                                            rows="10"
                                                            placeholder=""
                                                            name="noticeId"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.noticeId}
                                                            invalid={validation.touched.noticeId && validation.errors.noticeId ? true : false}
                                                            disabled={pageView === "view"}
                                                        />
                                                        { 
                                                            validation.touched.noticeId && validation.errors.noticeId && (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.noticeId}
                                                            </FormFeedback>
                                                            )
                                                        }
                                                    </div>
                                                </Col>
                                                <Col className="col-12">
                                                    <label
                                                        htmlFor="callbackUrl"
                                                        className="col-md-12 col-form-label"
                                                    >
                                                        Callback URL
                                                    </label>
                                                    <div className="col-md-12">
                                                        <Input
                                                            id="callbackUrl"
                                                            className="form-control"
                                                            type="text"
                                                            rows="10"
                                                            placeholder=""
                                                            name="callbackUrl"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.callbackUrl}
                                                            invalid={validation.touched.callbackUrl && validation.errors.callbackUrl ? true : false}
                                                            disabled={pageView === "view"}
                                                        />
                                                        { 
                                                            validation.touched.callbackUrl && validation.errors.callbackUrl && (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.callbackUrl}
                                                            </FormFeedback>
                                                            )
                                                        }
                                                    </div>
                                                </Col>
                                                <Col className="col-12">
                                                    <label
                                                        htmlFor="privacyNoticeUrl"
                                                        className="col-md-12 col-form-label"
                                                    >
                                                        Privacy Notice URL
                                                    </label>
                                                    <div className="col-md-12">
                                                        <Input
                                                            id="privacyNoticeUrl"
                                                            className="form-control"
                                                            type="text"
                                                            rows="10"
                                                            placeholder=""
                                                            name="privacyNoticeUrl"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.privacyNoticeUrl}
                                                            invalid={validation.touched.privacyNoticeUrl && validation.errors.privacyNoticeUrl ? true : false}
                                                            disabled={pageView === "view"}
                                                        />
                                                        { 
                                                            validation.touched.privacyNoticeUrl && validation.errors.privacyNoticeUrl && (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.privacyNoticeUrl}
                                                            </FormFeedback>
                                                            )
                                                        }
                                                    </div>
                                                </Col> */}
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                {/* Tools Box */}
                                <Col md={4}>
                                    <Card outline color="primary" className="border">
                                        <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                            <i className='bx bx-check'></i> Tools Box
                                        </h5>
                                        <CardBody>
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="update_date">Latest Update</label>
                                                <InputGroup>
                                                    <Input
                                                        id="update_date"
                                                        type="text"
                                                        className="form-control d-block"
                                                        placeholder=""
                                                        value={validation.values.update_date}
                                                        disabled="disabled"
                                                    />
                                                    <div className="input-group-append">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            disabled
                                                        >
                                                            <i
                                                                className="fa fa-calendar"
                                                                aria-hidden="true"
                                                            />
                                                        </button>
                                                    </div>
                                                </InputGroup>
                                            </div>
                                        </CardBody>
                                        <CardFooter>
                                            <Row>
                                                {/* <Col className="text-start">
                                                    <Button
                                                        color="danger"
                                                        className="btn btn-danger"
                                                        onClick={() =>
                                                            navigate(`/${_routeLink}`)
                                                        }
                                                    >
                                                        Back
                                                    </Button>
                                                </Col> */}
                                                <Col className="text-end">
                                                    <Button type="submit" color="primary" className="btn btn-success">
                                                        Save {waitSendData ? <Spinner size="sm" color="light" /> : null}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </CardFooter>
                                    </Card>                
                                </Col>
                                {/* SEO Box */}
                                {/* <Col md={12}>
                                
                                </Col> */}
                            </Row>
                        </Col>
                    </Form>
                </Row>
            }
          </Container>
        </div>
      </>
    );
};

export default withTranslation()(TagSettings)